import {API_URL, apiPatch} from '../api'

// 개별 유저 배지(grant row)의 획득일/만료일 직접 수정.
// PATCH /v3/admin/user-badges/:id  (id = grant row ID, badge_id 아님)
// granted_at/expired_at 중 최소 1개 필수. unix sec.
export interface IEditUserBadgeBody {
    granted_at?: number
    expired_at?: number
}

export const editUserBadge = async (id: string, body: IEditUserBadgeBody) => {
    return await apiPatch(API_URL, `admin/user-badges/${id}`, body)
}
